/* eslint-disable react/no-multi-comp */
/* eslint-disable react/display-name */
import {
  Assessment as DailyReportIcon,
  BarChart as ReportsIcon,
  CloudQueue as CloudIcon,
  Checklist as JobsIcon,
  History as ChangelistIcon,
  Inventory2 as GroupsIcon,
  Input as LogoutIcon,
  PersonSearch as UvCountIcon,
  PhoneAndroid as DeviceIcon,
  Settings as SettingsIcon,
  TrackChanges as TrackersIcon,
  TravelExplore as IpcountIcon,
} from '@mui/icons-material';

import { t } from 'i18n';

const cfg = [
  {
    title: t('Job Groups'),
    href: '/groups',
    icon: GroupsIcon,
  },
  {
    title: t('Job List'),
    href: '/jobs',
    icon: JobsIcon,
  },
  {
    title: t('Daily Report'),
    href: '/reports/jobdaily',
    icon: DailyReportIcon,
  },
  {
    title: t('Trackers Report'),
    href: '/reports/trackers',
    icon: TrackersIcon,
  },
  {
    title: t('Device Usage'),
    href: '/jobs/devusage',
    icon: DeviceIcon,
  },
  {
    title: t('IPUA UV Count'),
    href: '/jobs/ipuauv',
    icon: UvCountIcon,
  },
  {
    title: t('Jobs Changelist'),
    href: '/jobs/changelist',
    icon: ChangelistIcon,
  },
  {
    title: 'Extra Reports',
    href: '/reports/extra/',
    icon: ReportsIcon,
    needAdmin: true,
    children: [{
      title: 'Total Org Cost',
      href: '/reports/extra/total-org-cost',
      icon: ReportsIcon,
    }, {
      title: 'Monthly Cost',
      href: '/reports/extra/monthly-cost',
      icon: ReportsIcon,
    }, {
      title: 'Monthly Cost Details',
      href: '/reports/extra/monthly-cost-details',
      icon: ReportsIcon,
    }, {
      title: '订单价格',
      href: '/reports/extra/order-prices',
      icon: ReportsIcon,
    }],
  },
  {
    title: t('IP Count'),
    href: '/ipcount',
    icon: IpcountIcon,
  },
  {
    title: t('Cloudboard'),
    href: '/cloudboard',
    icon: CloudIcon,
    needAdmin: true,
  },
  {
    title: t('Settings'),
    href: '/settings',
    icon: SettingsIcon,
  },
  {
    title: t('Logout'),
    href: '/auth/logout',
    icon: LogoutIcon,
    workspaceTab: false,
  },
];

export default cfg;
